import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    current_courses: {
      cards: [],
    },
    events: [],
    feed  : {
      items: [],
    },
    idea: {
      themes: [],
      ideas : [],
    },
    rating: [],
  },
  getters: {
    current_courses: ({current_courses})=> current_courses,
    events         : ({events})=> events,
    feed           : ({feed})=> feed,
    idea           : ({idea})=> idea,
    rating         : ({rating})=> rating,
  },
  mutations: {
    SET_MAIN(state, value) {
      state.current_courses = value.current_courses;
      state.events = value.events;
      state.feed = value.feed;
      state.idea = value.idea;
      state.rating = value.rating;
    },
  },
  actions: {
    async get_main({commit}) {
      try {
        let main_page = await api.main_page.get_main();
        commit('SET_MAIN', main_page.data);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
